import Segmented from './src';
import { withInstall } from '../_util/type';
export default withInstall(Segmented);